export default __webpack_public_path__ + "static/media/Loader.c04cde38.gif";